import { isRecord } from './cardModel';

export interface CardDraft {
  values: Record<string, unknown>;
  step?: number;
  furthest?: number;
}

const KEY_PREFIX = 'alpha-card-draft:';

const wholeOrUndefined = (value: unknown): number | undefined =>
  typeof value === 'number' && Number.isInteger(value) && value >= 0
    ? value
    : undefined;

export const readCardDraft = (token: string): CardDraft | undefined => {
  try {
    const raw = window.sessionStorage.getItem(`${KEY_PREFIX}${token}`);
    if (raw == null) {
      return undefined;
    }
    const parsed: unknown = JSON.parse(raw);
    if (!isRecord(parsed) || !isRecord(parsed.values)) {
      return undefined;
    }
    return {
      values: parsed.values,
      step: wholeOrUndefined(parsed.step),
      furthest: wholeOrUndefined(parsed.furthest),
    };
  } catch {
    return undefined;
  }
};

export const writeCardDraft = (token: string, draft: CardDraft): boolean => {
  try {
    window.sessionStorage.setItem(
      `${KEY_PREFIX}${token}`,
      JSON.stringify(draft),
    );
    return true;
  } catch {
    return false;
  }
};

export const clearCardDraft = (token: string): boolean => {
  try {
    window.sessionStorage.removeItem(`${KEY_PREFIX}${token}`);
    return true;
  } catch {
    return false;
  }
};
